import InsertChartOutlinedIcon from "@mui/icons-material/InsertChartOutlined";
import React, { ReactNode } from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { PageDrawer } from "../PageDrawer";

interface IPagePanelsDrawerProps {
    open: boolean;
    fitToContainer?: boolean;
    children: ReactNode;
    onClose: () => void;
}

export const PagePanelsDrawer = (props: IPagePanelsDrawerProps) => (
    <PageDrawer open={props.open} title={Translations.Panels} icon={<InsertChartOutlinedIcon />} onClose={props.onClose} fitToContainer={props.fitToContainer}>
        {props.children}
    </PageDrawer>
);
